var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignMsgHistoryReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.74,
    height: 31.01,
    viewBox: "0 0 26.74 31.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPORT",
    transform: "translate(0.21 0.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M23.46,15.33V10.57L13.43.54H3.4A2.859,2.859,0,0,0,.54,3.4V26.33A2.87,2.87,0,0,0,3.41,29.2h8.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M13.43,1.54v7.6a2.433,2.433,0,0,0,2.43,2.43h7.6",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M14.82,19.58a6.28,6.28,0,1,0,4.83-2.09.152.152,0,0,0-.15.14h0v2.74",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M18.76,24.51l-2.58-3.7a.266.266,0,0,1,.37-.37l3.7,2.58a1.063,1.063,0,0,1-1.22,1.74,1.07,1.07,0,0,1-.26-.26Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignMsgHistoryReportIcon);
export default __webpack_public_path__ + "static/media/Campaign-msg-history-report-Icon.bbfde2171b0fc4dedebded5bc53b9479.svg";
export { ForwardRef as ReactComponent };